type ResolvePathParams = {
  href: string;
  path?: string;
  skipHash?: boolean;
  skipQuery?: boolean;
};

/**
 * Резолвит пути относительно href с сохранением query и hash
 * В случае невалидных путей отдает изначальный href
 */
export function resolvePath(params: ResolvePathParams) {
  const { href, path = './', skipHash, skipQuery } = params;
  try {
    const url = new URL(href);
    const updatedUrl = new URL(path, href);

    if (!skipHash) {
      updatedUrl.hash = url.hash;
    }

    if (!skipQuery) {
      updatedUrl.search = url.search;
    }

    return updatedUrl.toString();
  } catch (e) {
    return href;
  }
}
